<template>
  <div class="content" v-loading="loading">
    <el-button type="primary" @click="openEditWin('create')">添加</el-button>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="sort" label="排序"> </el-table-column>
      <el-table-column prop="media_id" label="文件ID"> </el-table-column>
      <el-table-column prop="name" label="文件名"> </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    <!--对话框-->
    <el-dialog
      class="dialog600"
      append-to-body
      v-if="sub_dialogVisible"
      :title="editType === 'create' ? '添加音乐' : '修改音乐'"
      :visible.sync="sub_dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="150px"
        :rules="editRule"
      >
        <div class="form-info">
          <el-form-item label="选择音乐（可搜索）" prop="media_id">
            <el-select
              placeholder="请选择音乐（可搜索）"
              filterable
              v-model="editOne.media_id"
              style="width:100%"
            >
              <el-option
                v-for="t in devSelect"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model="editOne.sort"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="sub_dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import realtimeApi from "@/api/audio/realtime";
import mediaApi from "@/api/audio/media";
export default {
  name: "dalogMediaList",
  props: {
    nowId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      sub_dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        pid: null,
      },
      cnt_all: 0,
      editType: -1,
      editRule: {
        media_id: [{ required: true, message: "请选择音乐", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      editOne: {},
      devSelect: [],
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取该设备所选媒体文件列表
      this.pageInfo.page = pageIndex;
      this.pageInfo.pid = this.nowId;
      this.loading = true;
      realtimeApi.relatedList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getMediaList();
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openEditWin(index) {
      console.log('openEditWin', index);
      if (index === "create") {
        this.editOne = {
          media_id: null,
          task_id: this.nowId,
          sort: null
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          media_id: index.media_id,
          task_id: this.nowId,
          sort: index.sort,
        };
        this.editType = "update";
      }
      this.sub_dialogVisible = true;
    },
    updateItem() {
      realtimeApi.relatedEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.sub_dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      console.log('this.editOne', this.editOne)
      realtimeApi.relatedAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.sub_dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          realtimeApi.relatedDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeSwitch(id, ste) {
      // realtimeApi.planTaskSet({ plan_id: id, ste: ste }).then((res) => {
      //   if (res.data.code === 1000) {
      //     this.$message.success("设置成功");
      //     this.getTableData(this.pageInfo.page);
      //   } else {
      //     this.$message.error(res.data.message);
      //   }
      // });
    },
    //设备列表
    getMediaList() {
      mediaApi
        .mediaList({
          page: 1,
          pageSize: 2000,
        }).then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data;
            this.devSelect = resData.list;
          }
        });
    }, 
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.content {
  width: 100%;
}
</style>
